import { useQuery } from '@tanstack/react-query';

import { RequestParamsV2 } from '@xemplo/gp-types';
import { useHttpClient } from '@xemplo/http';
import { useAppSettings } from '@xemplo/xemplo-app-settings';

import { tagQueries } from './gp-tags-query-options';

/**
 * Hook to fetch tags list with given parameters
 */
export function useTagsListQuery(params: RequestParamsV2, enabled = true) {
  const { applicationApiUrl } = useAppSettings();
  const { client } = useHttpClient();

  return useQuery({
    ...tagQueries.list(params, client, applicationApiUrl),
    enabled: !!applicationApiUrl && enabled,
  });
}
